import Card from 'components/Layout/Card';
import CountryAnalyticsChart from 'pages/Admin/Dashboard/CountryAnalyticsChart';
import MembersAnalyticsChart from 'pages/Admin/Dashboard/MembersAnalyticsChart';
import AllReports from 'pages/Admin/Reports/AllReports';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const ConferenceCoOrdinatorResourceTab = ({ commonYear, isReport }) => {
  const params = useParams();

  const [tabType, setTabType] = useState('0');
  const activeClass = 'p-3 bg-new-car color-white text-16-500';
  const inActiveClass = 'p-3 color-dark-blue text-16-500 pointer';
  return (
    <>
      <div>
        <Card className="mt-3">
          <div className="d-flex align-items-center flex-wrap gap-2">
            <div
              className={tabType === '0' ? activeClass : inActiveClass}
              onClick={() => {
                setTabType('0');
              }}
            >
              IFERP Member’s Analytics
            </div>
            <div
              className={tabType === '1' ? activeClass : inActiveClass}
              onClick={() => {
                setTabType('1');
              }}
            >
              Country Wise Analytics
            </div>
          </div>
        </Card>

        {tabType === '0' && (
          <MembersAnalyticsChart commonYear={commonYear} isReport={isReport} />
        )}

        {tabType === '1' && (
          <CountryAnalyticsChart commonYear={commonYear} isReport={isReport} />
        )}
      </div>

      {params?.type === 'overall-report' && tabType === '1' && <AllReports />}
    </>
  );
};

export default ConferenceCoOrdinatorResourceTab;
